import { storeToRefs } from "pinia"
import { useProjectStore } from "@/store/projects.store"
import { type Project } from "@/models/project.model"
import { helpers } from "@vuelidate/validators"

function isUniqueNameAndExecutor(value: string, project: Project) {
  const projectStore = useProjectStore()
  const { projects } = storeToRefs(projectStore)

  return !projects.value.some((proj: Project) => {
    return (
      proj.name.toLowerCase() === project.name.toLowerCase() &&
      proj.executor?.id === project.executor?.id &&
      proj.id !== project.id // Exclude the current project from the check
    )
  })
}

export const isUniqueNameAndExecutorValidator = helpers.withMessage(
  "Er bestaat al een project met deze naam en financieel verantwoordelijke",
  isUniqueNameAndExecutor
)
